import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PromptSource } from '@/hooks/useAppDownloadPrompt';

interface AppDownloadBannerProps {
  onDownload: (source: PromptSource) => void;
  onClose: () => void;
  onShown: (source: PromptSource) => void;
}

/** Slim dismissible bar sitting right above the bottom tab bar on mobile web. */
export function AppDownloadBanner({ onDownload, onClose, onShown }: AppDownloadBannerProps) {
  const { t } = useTranslation();

  useEffect(() => {
    onShown('banner');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed bottom-16 left-0 right-0 z-40 border-t border-border bg-card/95 backdrop-blur px-3 py-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]">
      <div className="flex items-center gap-2">
        <Download className="h-4 w-4 shrink-0 text-primary" />
        <p className="flex-1 text-xs text-muted-foreground">{t('appDownload.bannerText')}</p>
        <Button size="sm" className="h-8 px-3 text-xs" onClick={() => onDownload('banner')}>
          {t('appDownload.bannerCta')}
        </Button>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 shrink-0"
          onClick={onClose}
          aria-label={t('appDownload.close')}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
